import { ThemeProperties } from '../../core';

export interface CommonInputTheme {
	baseBorderColor: string;
	basePaddingHorizontal: string;
	basePaddingVertical: string;
	baseFont: string;
	baseTextColor: string;
	baseBorderRadius: string;
	baseBackground: string;

	focusRingColor: string;

	hoverBorderColor: string;

	readOnlyBackground: string;
	readOnlyBorderColor: string;

	placeholderTextColor: string;

	labelMarginBottom: string;

	descriptionMarginBottom: string;

	invalidBorderColor: string;

	helpTextGap: string;
}
export const theme = new ThemeProperties('commonInput');
